/* frontend/src/utils/api.js */
import axios from 'axios';

// Configure axios with production URL and CSRF settings
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL, // https://api.serrand.org
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add CSRF token for POST, PUT, DELETE requests
api.interceptors.request.use((config) => {
  if (['post', 'put', 'delete'].includes(config.method.toLowerCase())) {
    const value = `; ${document.cookie}`;
    const parts = value.split('; csrftoken=');
    if (parts.length === 2) {
      config.headers['X-CSRFToken'] = parts.pop().split(';').shift();
    }
    // Ensure correct Content-Type for FormData
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
  }
  return config;
});

// Article APIs
export const getArticles = () => api.get('/api/articles/');
export const getArticle = (id) => api.get(`/api/articles/${id}/`);
export const createArticle = (data) => api.post('/api/articles/create/', data);
export const updateArticle = (id, data) => api.put(`/api/articles/${id}/update/`, data);
export const deleteArticle = (id) => api.delete(`/api/articles/${id}/delete/`);
export const likeArticle = (id) => api.post(`/api/articles/${id}/likes/`);
export const getComments = (id) => api.get(`/api/articles/${id}/comments/`);
export const postComment = (id, content) => api.post(`/api/articles/${id}/comment/`, { content });
export const shareArticle = (id, platform) => api.post(`/api/articles/${id}/share/`, { platform });
